// extracted by mini-css-extract-plugin
module.exports = {"cancel-description":"_2TiDN","wrapper":"_3ZYoL","title":"cNcqt","text-area":"_3paZ_","popup-button-wrapper":"_3-aI9"};